import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { styled as muiStyled } from '@mui/material/styles';
import Select from '../UI/Select';
import { getItems } from '../../lib/SessionStorage';
import { Background } from '../../styles/themeColors';
import ServiceLocalization from './ServiceLocalization';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import SelectionList from 'common/SelectionList';
import { STORAGE_KEYS } from 'constants/general';

const ContainerGrid = muiStyled(Grid)({
  minHeight: '100px',
  background: Background.shaded,
});

interface Props {
    selectedVendorId?: number;
    filterUpdate: (filters: ServiceListFilter) => void;
    loading: boolean;
}

interface SelectedOption {
    value: string;
    id?: string;
}

export interface ServiceListFilter {
    publishStatus: SelectedOption;
    country: number[];
}

const ServiceListingFilter = ({ selectedVendorId,
    filterUpdate,
    loading
}: Props) => {

    const [selectedFilters, setSelectedFilters] = useState<ServiceListFilter>({
        publishStatus: { value: ServiceLocalization.listing.filter.all },
        country: [],
    });

    const isMounted = React.useRef(true);
    // fetching data from session storage
    const countries = getItems(STORAGE_KEYS.COUNTRIES);
    const publishStatuses = getItems(STORAGE_KEYS.SERVICE_STATUSES);

    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);


    React.useEffect(() => {
        filterUpdate(selectedFilters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFilters]);


    React.useEffect(() => {
        setSelectedFilters({
            publishStatus: { value: ServiceLocalization.listing.filter.all },
            country: [],
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVendorId]);  // eslint-disable-next-line react-hooks/exhaustive-deps

    return (
        <>

            <ContainerGrid size={12}>
                <FlexboxContainerComponent flexDirection='row' justifyContent='space-between' padding='20px 20px'>
                    <FlexboxContainerComponent flexDirection='row' gap='16px'>
                        <Select
                            label={ServiceLocalization.listing.filter.publishStatus}
                            disabled={loading}
                            labelPosition="top"
                            options={publishStatuses.map((status: any) => ({
                                value: status.name,
                                id: status.id,
                            }))}
                            onChange={(event) => {
                                setSelectedFilters({
                                    ...selectedFilters,
                                    publishStatus: { value: event.target.value, id: event.target.id },
                                });
                            }}
                            value={selectedFilters.publishStatus.value}
                            defaultValue={ServiceLocalization.listing.filter.all}
                            width="200px"
                            displayEmpty={ServiceLocalization.listing.filter.all}
                        />
                        <div style={{ marginTop: -2.5 }}>
                            <SelectionList
                                dataList={countries.map((country: any) => ({
                                    name: country.countryName,
                                    id: country.id,
                                }))}
                                filteredIds={selectedFilters.country}
                                setFilterIds={(ids: (string | number)[]) => {
                                    setSelectedFilters({
                                        ...selectedFilters,
                                        country: ids as number[]
                                    });
                                }}
                                textLabel={ServiceLocalization.listing.filter.country}
                                inputWidth='200px'
                                initialAllSelected={false}
                                menuItemClassName='select-menu-item'
                                placeHolder={ServiceLocalization.listing.filter.selectCountry}
                                disabled={loading}
                            />
                        </div>
                    </FlexboxContainerComponent>
                </FlexboxContainerComponent>
            </ContainerGrid>
        </>
    );
};

export default React.memo(ServiceListingFilter);
